import { Col, Row, Card, FormGroup, FormControl, Button } from 'react-bootstrap';
import DateTime from 'react-datetime';

const IncentivesSearch = props => (
  <Card className="submission-filter admin-search-filter">
    <Card.Body>
      <Row>
        <Col md={3}>
          <FormGroup>
            Incentive name
            <FormControl
              onChange={props.onNameChange}
              placeholder="Incentive name keyword"
              value={props.nameValue}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            End date from
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={props.dateFromValue}
              onChange={props.onDateFromChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Date from'
              }}
            />
          </FormGroup>
        </Col>
        <Col md={3}>
          <FormGroup>
            End date to
            <DateTime
              timeFormat={false}
              dateFormat="DD/MM/YYYY"
              value={props.dateToValue}
              onChange={props.onDateToChange}
              closeOnSelect
              inputProps={{
                placeholder: 'Date to'
              }}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6} className="actions">
          <Button
            className="red-ghost-btn"
            onClick={props.onClear}
          >Clear search/filters
          </Button>
          <Button
            className="red-ghost-btn"
            onClick={props.onSearch}
          >Search
          </Button>
        </Col>
      </Row>
    </Card.Body>
  </Card>
);

export default IncentivesSearch;
